import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../packages/CustomModal";
import WPTabs from "../../packages/WPTabs";

const ColumnMappingHelpDialogs = ({ closeColumnMappingTroubleshoot }) => {
  const { t } = useTranslation();

  const columnMappingTroubleshootTabs = useMemo(
    () => [
      {
        id: "general-help",
        title: t("helpInformation.columnMappingTroubleshootGeneralHelp"),
      },
      {
        id: "auto-detect-columns",
        title: t("helpInformation.columnMappingTroubleshootAutoDetectColumns"),
      },
      {
        id: "import-column-mapping",
        title: t(
          "helpInformation.columnMappingTroubleshootImportColumnMapping",
        ),
      },
    ],
    [t],
  );

  return (
    <CustomModal
      header={t("analyseData.columnMapping")}
      onModalClose={closeColumnMappingTroubleshoot}
      confirmBtn={t("ValueStrings.okay")}
      customclass="column-mapping-troubleshoot-modal"
      custombodyclass="column-mapping-troubleshoot-dialog__body"
      width="700px"
    >
      <WPTabs
        tabs={columnMappingTroubleshootTabs}
        className="column-mapping-troubleshoot-tabs"
      >
        <ul className="column-mapping-troubleshoot-dialog__list">
          <li>{t("helpInformation.columnMappingTroubleshootGeneralHelp1")}</li>
          <li>{t("helpInformation.columnMappingTroubleshootGeneralHelp2")}</li>
          <li>{t("helpInformation.columnMappingTroubleshootGeneralHelp3")}</li>
        </ul>
        <ul className="column-mapping-troubleshoot-dialog__list">
          <li>{t("helpInformation.columnMappingTroubleshootAutoDetectColumns1")}</li>
          <li>
            {t("helpInformation.columnMappingTroubleshootAutoDetectColumns2")}
            <ul className="column-mapping-troubleshoot-dialog__sub-list">
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootAutoDetectColumns2a",
                )}
              </li>
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootAutoDetectColumns2b",
                )}
              </li>
            </ul>
          </li>
          <li>{t("helpInformation.columnMappingTroubleshootAutoDetectColumns3")}</li>
        </ul>
        <ul className="column-mapping-troubleshoot-dialog__list">
          <li>{t("helpInformation.columnMappingTroubleshootImportColumnMapping1")}</li>
          <li>
            {t("helpInformation.columnMappingTroubleshootImportColumnMapping2")}
            <ul className="column-mapping-troubleshoot-dialog__sub-list">
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootImportColumnMapping2a",
                )}
              </li>
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootImportColumnMapping2b",
                )}
              </li>
            </ul>
          </li>
          <li>{t("helpInformation.columnMappingTroubleshootImportColumnMapping3")}</li>
          <li>{t("helpInformation.columnMappingTroubleshootImportColumnMapping4")}</li>
          <li>
            {t("helpInformation.columnMappingTroubleshootImportColumnMapping5")}
            <ul className="column-mapping-troubleshoot-dialog__sub-list">
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootImportColumnMapping5a",
                )}
              </li>
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootImportColumnMapping5b",
                )}
              </li>
              <li>
                {t(
                  "helpInformation.columnMappingTroubleshootImportColumnMapping5c",
                )}
              </li>
            </ul>
          </li>
        </ul>
      </WPTabs>
    </CustomModal>
  );
};

export default ColumnMappingHelpDialogs;
